import 'reflect-metadata';
import TYPES from 'di/types';
import { Container } from 'inversify';
import { NetworkService } from '@collaborator/npm_modules/dist/components/NetworkService';
import Translate from 'srcJs/components/Translate';
import User from 'srcJs/components/user/User';
import SourceLocalStorage from 'srcJs/components/user/source/SourceLocalStorage';
var container = new Container();
container.bind(TYPES.NetworkService).toDynamicValue(function () {
  return new NetworkService();
}).inSingletonScope();
container.bind(TYPES.Translate).to(Translate).inSingletonScope();
container.bind(TYPES.UserSource).to(SourceLocalStorage).inSingletonScope();
container.bind(TYPES.User).to(User).inSingletonScope();
export default container;